import { SxProps, Theme } from "@mui/material";
import colorsConstants from "src/app/constants/colors.constants";

const styles = {
  parent: {
    backgroundColor: colorsConstants.mainContentBackgroundColor,
    flex: 1,
    display: "flex",
    height: "100vh",
  },
  drawerAwareContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    padding: "24px",
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    width: "90%",
  },
  titleText: {
    color: colorsConstants.primaryText,
    fontSize: 24,
    textAlign: "center",
    flex: 1,
    marginLeft: "24px",
  },
  calendarContainer: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    boxShadow: "none",
  },
  calendarTitleText: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
    mb: 1,
    alignSelf: "flex-start",
  },
  dayTasksContainer: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
    minHeight: 300,
  },
  dayTitleText: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
    mb: 2,
  },
  subTitleText: {
    color: colorsConstants.primaryText,
    opacity: 0.7,
    mt: 2,
  },
  taskTimelineItem: {
    p: 1.5,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
    mb: 1.5,
  },
  taskTimelineItemOverdue: {
    border: "2px solid rgb(253, 184, 184)",
    backgroundColor: colorsConstants.emergencyRequestCardBackground,
  },
  taskTimelineItemCompleted: {
    border: "2px solid rgba(76, 175, 80, 0.3)",
  },
  taskTitleRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 1,
    mb: 0.5,
  },
  taskTitleText: {
    color: colorsConstants.primaryText,
    fontWeight: 700,
  },
  taskMetaText: {
    color: colorsConstants.primaryText,
    mb: 0.5,
    opacity: 0.85,
    fontSize: 13,
  },
  searchingLoader: {
    display: "flex",
    justifyContent: "center",
    py: 4,
  },
  noTasksText: {
    color: colorsConstants.primaryText,
    opacity: 0.7,
  },
  selectorContainer: {
    width: "100%",
  },
  selectorPaper: {
    p: 2,
    borderRadius: 2,
    border: "1px solid rgba(0, 0, 0, 0.08)",
    backgroundColor: colorsConstants.drawerListItemContainerSelected,
    boxShadow: "none",
  },
  chipRow: {
    display: "flex",
    gap: 1,
    flexWrap: "wrap",
    mb: 1,
  },
  eventTimelineItem: {
    p: 1.5,
    borderRadius: 2,
    border: "1px solid rgba(25, 118, 210, 0.25)",
    backgroundColor: "rgba(25, 118, 210, 0.04)",
    boxShadow: "none",
    mb: 1.5,
    cursor: "pointer",
    transition: "transform 0.12s, box-shadow 0.15s",
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: "0 4px 16px rgba(25,118,210,0.12)",
    },
  },
  sectionLabel: {
    color: colorsConstants.primaryText,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 1.2,
    textTransform: "uppercase",
    opacity: 0.5,
    mt: 1,
    mb: 1,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
